/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { getPdfStatus } from "./getPdfStatus";

export function pdfClient() {
  return { getPdfStatus }
}